import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  details: null,
};

export const monitoringSlice = createSlice({
  name: 'monitoring',
  initialState,
  reducers: {
    setMonitoringDetails: (state, action) => {
      state.details = action.payload;
    },

    resetMonitoring: () => initialState,
  },
});

export const {
  setMonitoringDetails,

  resetMonitoring,
} = monitoringSlice.actions;

export default monitoringSlice.reducer;
